module.exports = __webpack_public_path__ + "assets/media/swallow_split_new.4c243685.mp4";